"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { useEffect, useState } from "react";
import type { KeyboardEvent as ReactKeyboardEvent } from "react";
import { SortDirection } from "@/entities/ISort";
import CommonTableSortIcon from "@/components/user/utils/icons/CommonTableSortIcon";
import type { CommonSelectItemProps } from "../CommonSelect";
export default function CommonTabsTab(props) {
  const $ = _c(46);
  const {
    item,
    activeItem,
    setSelected,
    sortDirection,
    onKeyDown,
    buttonRef,
    disabled: t0,
    fill: t1
  } = props;
  const disabled = t0 === undefined ? false : t0;
  const fill = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== activeItem || $[1] !== item.value) {
    t2 = () => item.value === activeItem;
    $[0] = activeItem;
    $[1] = item.value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getIsActive = t2;
  const [isActive, setIsActive] = useState(getIsActive());
  let t3;
  if ($[3] !== getIsActive) {
    t3 = () => {
      setIsActive(getIsActive());
    };
    $[3] = getIsActive;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== activeItem) {
    t4 = [activeItem];
    $[5] = activeItem;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== isActive) {
    t5 = () => {
      let response;
      if (isActive) {
        response = "tw-bg-iron-800 tw-text-iron-100";
      } else {
        response = " tw-bg-iron-950 hover:tw-bg-iron-900 tw-text-iron-500 hover:tw-text-iron-100";
      }
      return response;
    };
    $[7] = isActive;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const getDynamicClasses = t5;
  const [dynamicClasses, setDynamicClasses] = useState(getDynamicClasses());
  let t6;
  if ($[9] !== getDynamicClasses) {
    t6 = () => {
      setDynamicClasses(getDynamicClasses());
    };
    $[9] = getDynamicClasses;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isActive) {
    t7 = [isActive];
    $[11] = isActive;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  useEffect(t6, t7);
  const [shouldRotate, setShouldRotate] = useState(false);
  let t8;
  if ($[13] !== disabled || $[14] !== item.value || $[15] !== setSelected) {
    t8 = () => {
      if (disabled) {
        return;
      }
      setSelected(item.value);
      setShouldRotate(false);
    };
    $[13] = disabled;
    $[14] = item.value;
    $[15] = setSelected;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const onSelected = t8;
  const tooltip = "tooltip" in item && typeof item.tooltip === "string" ? item.tooltip : undefined;
  const t9 = fill ? "tw-flex-1" : undefined;
  const t10 = isActive ? "tw-bg-gradient-to-b tw-from-iron-700 tw-to-iron-800" : undefined;
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = clsx("tw-p-[1px] tw-flex tw-rounded-lg", t9, t10);
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = isActive ? 0 : -1;
  let t13;
  let t14;
  if ($[20] !== disabled) {
    t13 = () => !disabled && setShouldRotate(true);
    t14 = () => !disabled && setShouldRotate(false);
    $[20] = disabled;
    $[21] = t13;
    $[22] = t14;
  } else {
    t13 = $[21];
    t14 = $[22];
  }
  const t15 = `${dynamicClasses} ${disabled ? "tw-cursor-not-allowed tw-opacity-60" : ""} ${fill ? "tw-flex-1" : ""} ${"tw-px-3 tw-py-1.5 tw-text-sm"} tw-whitespace-nowrap tw-leading-5 tw-font-medium tw-border-0 tw-rounded-lg tw-transition-all tw-duration-300 tw-ease-out tw-flex tw-items-center tw-justify-center tw-gap-2`;
  let t16;
  if ($[23] !== item.badge) {
    t16 = !!item.badge && item.badge > 0 && <span className="tw-bg-primary-500 tw-text-white tw-text-[10px] tw-font-bold tw-px-1.5 tw-py-0.5 tw-rounded-full tw-min-w-[18px] tw-h-[18px] tw-flex tw-items-center tw-justify-center">{item.badge}</span>;
    $[23] = item.badge;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== isActive || $[26] !== shouldRotate || $[27] !== sortDirection) {
    t17 = sortDirection && <span className="-tw-mt-1"><CommonTableSortIcon direction={isActive ? sortDirection : SortDirection.DESC} isActive={isActive} shouldRotate={isActive && shouldRotate} /></span>;
    $[25] = isActive;
    $[26] = shouldRotate;
    $[27] = sortDirection;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== buttonRef || $[30] !== disabled || $[31] !== isActive || $[32] !== item.label || $[33] !== onKeyDown || $[34] !== onSelected || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== t16 || $[40] !== t17 || $[41] !== tooltip) {
    t18 = <button type="button" role="tab" aria-selected={isActive} tabIndex={t12} ref={buttonRef} title={tooltip} disabled={disabled} onClick={onSelected} onKeyDown={onKeyDown} onMouseEnter={t13} onMouseLeave={t14} className={t15}>{item.label}{t16}{t17}</button>;
    $[29] = buttonRef;
    $[30] = disabled;
    $[31] = isActive;
    $[32] = item.label;
    $[33] = onKeyDown;
    $[34] = onSelected;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
    $[41] = tooltip;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t11 || $[44] !== t18) {
    t19 = <div className={t11}>{t18}</div>;
    $[43] = t11;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
}